import { SelectDropdown } from "../SelectDropdown";

export const SortOrderSelect = ({ options, value, onChange }) => {
    return (
        <div className="w-72">
            <SelectDropdown
                options={options}
                value={value}
                onChange={onChange}
                selectClassname="bg-white !px-3 !py-1.5"
                dropdownClassname="!z-[150]"
            />
        </div>
    );
};


